module.exports = __webpack_public_path__ + "img/65_4.db5bcb8f.png";